import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  FileInput,
  ImageField,
  useCreate,
  useNotify,
  useRedirect,
  Toolbar,
  SaveButton,
  required
} from 'react-admin';
import { uploadImage } from '../../../config/services/strapi/strapi';

function PLGImagenesInicioCreate() {
  const [create] = useCreate();
  const redirect = useRedirect();
  const notify = useNotify();

  // Cambia esto por el nombre exacto que funcionó en tu App.tsx
  const resourceName = 'plg-imagenes-inicioss';

  const handleSubmit = async (data: any) => {
    try {
      const token = localStorage.getItem('strapi_jwt');
      if (!token) {
        notify('No se encontró el token de autenticación', { type: 'error' });
        return;
      }

      // 1. Subir la imagen a Strapi (Media Library)
      if (!data.portada || !data.portada.rawFile) {
        notify('La portada es obligatoria', { type: 'warning' });
        return;
      }
      
      const portadaUploaded = await uploadImage(data.portada.rawFile, token);

      // 2. Preparar el payload para la colección PLG
      const payload: Record<string, any> = {
        titulo: data.titulo,
        portada: { id: portadaUploaded.id }, // Se envía el ID de la imagen subida
      };

      // 3. Crear el registro en la base de datos
      create(resourceName, { data: payload }, {
        onSuccess: () => {
          notify('Registro PLG creado con éxito', { type: 'success' });
          redirect('list', resourceName);
        },
        onError: (error: any) => {
          notify(`Error: ${error.message}`, { type: 'error' });
        },
      });

    } catch (error) {
      console.error('Error during creation:', error);
      notify('Error al procesar la imagen o crear el registro', { type: 'error' });
    }
  };

  return (
    <Create>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <TextInput
          source="titulo"
          label="Título de la Imagen"
          validate={[required()]}
          fullWidth
        />

        <FileInput
          source="portada"
          label="Imagen de Portada"
          multiple={false}
          validate={[required()]}
        >
          <ImageField source="src" title="title" />
        </FileInput>
      </SimpleForm>
    </Create>
  );
}

export default PLGImagenesInicioCreate;